import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ensureData360Workspace, PHANTOM_PROJECT_PREFIX } from '../api/data360'
import { useProjects } from '../contexts/ProjectsContext'

export { PHANTOM_PROJECT_PREFIX }

export function parsePhantomData360Id(projectId: string | undefined): number | null {
  if (!projectId || !projectId.startsWith(PHANTOM_PROJECT_PREFIX)) return null
  const n = Number(projectId.slice(PHANTOM_PROJECT_PREFIX.length))
  return Number.isInteger(n) && n > 0 ? n : null
}

/**
 * Redirects /projects/d360-shadow-{data360Id}/… to the real WPS shadow UUID.
 */
export function usePhantomProjectRedirect(): boolean {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { patchProjectFromEnsure } = useProjects()
  const phantomData360Id = parsePhantomData360Id(id)
  const [resolving, setResolving] = useState(phantomData360Id != null)

  useEffect(() => {
    if (!id || phantomData360Id == null) return

    let cancelled = false

    ;(async () => {
      try {
        const result = await ensureData360Workspace(phantomData360Id)
        if (cancelled) return
        patchProjectFromEnsure(result)
        const suffix = location.pathname.replace(`/projects/${id}`, '') || ''
        navigate(`/projects/${result.shadowProjectId}${suffix}${location.search}`, { replace: true })
      } catch (err) {
        console.error('Failed to resolve phantom project id:', err)
      } finally {
        if (!cancelled) setResolving(false)
      }
    })()

    return () => {
      cancelled = true
    }
  }, [id, phantomData360Id, location.pathname, location.search, navigate, patchProjectFromEnsure])

  return phantomData360Id != null && resolving
}
